import React from 'react';
import {
  AcademicCapIcon,
  MapPinIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline';
import Card from './Card';

const USE_CASES = [
  {
    title: 'Parking spots',
    body: 'Rent out a driveway, garage bay, or lot by the hour, day, or month.',
    Icon: MapPinIcon,
  },
  {
    title: 'Tutoring and training',
    body: 'Sell your time in sessions — lessons, coaching, or personal training.',
    Icon: AcademicCapIcon,
  },
  {
    title: 'Tools and equipment',
    body: 'Put idle gear to work: mowers, trailers, cameras, power tools.',
    Icon: WrenchScrewdriverIcon,
  },
];

const UseCaseGrid: React.FC = () => (
  <div className="grid gap-6 md:grid-cols-3">
    {USE_CASES.map(({ title, body, Icon }) => (
      <Card key={title}>
        <Icon className="h-8 w-8 text-primary-600" aria-hidden="true" />
        <h3 className="mt-4 text-lg font-semibold text-gray-900">{title}</h3>
        <p className="mt-2 text-gray-600">{body}</p>
      </Card>
    ))}
  </div>
);

export default UseCaseGrid;
